<template>
    <div>

        <config-main-title>
            Restrição de Horários de Acesso
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma restrição identificado.'" 
                icon="fa-solid fa-clock"
                :action="'Incluir'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="badge badge-secondary">#{{ dado.id_horario_acesso }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else>
                            <button type="button" class="btn btn-sm btn-outline-secondary ml-3" @click="acessos(dado)">
                                <i class="fas fa-user-lock mr-2"></i>
                                {{ dado.acessos.length }}
                            </button>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_horario_acesso ) ? '' : 'Nova' }}
                            Restrição de Horário de Acesso
                            <span v-if="item && item.id_horario_acesso">
                                #{{ item.id_horario_acesso }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="alert alert-info">
                            Informar os dias e horários que o usuário <strong>NÃO</strong> poderá acessar o sistema.
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Mensagem"
                                    :validate="validate"
                                    v-model="item.st_mensagem" />
                            </div>
                        </div>

                        <div class="row my-3">
                            <div class="col col-12 d-flex flex-column" v-if="item.js_dias">
                                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                    <button type="button" class="btn" 
                                        :class="item.js_dias[dia - 1] ? 'btn-secondary' : 'btn-outline-secondary'" 
                                        @click="$set(item.js_dias, dia - 1, !item.js_dias[dia - 1])"
                                        v-for="dia in 7" :key="dia">
                                        {{ dias[dia - 1] }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="form-row" v-for="(horario, ihx) in item.js_horarios" :key="ihx">
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    sizing="sm"
                                    type="time"
                                    required
                                    :validate="validate"
                                    v-model="horario.inicio">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button type="button" class="btn btn-outline-danger" @click="remover_horario(ihx)">
                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    sizing="sm" 
                                    icon="fa-solid fa-less-than-equal"
                                    type="time"
                                    required
                                    :validate="validate"
                                    v-model="horario.fim" />
                            </div>
                        </div>

                        <button type="button" class="btn btn-sm btn-primary" @click="incluir_horario()">
                            <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="horarioAcesso" :id="item.id_horario_acesso" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_horario_acesso ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            outros_acessos: [],
            is_reembolso: false, 
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        EdicaoAcessos, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        tem_acesso: function () { 
            return this.$route.meta.model == 'atendimento'
                || this.$route.meta.model == 'receita';
        },

        dias: function () { 
            return [
                'Dom',
                'Seg',
                'Ter',
                'Qua',
                'Qui',
                'Sex', 
                'Sab'
            ];
        }

    },

    methods: { 
        remover_horario (idx) { 
            this.item.js_horarios.splice(idx, 1);
        },

        incluir_horario () { 
            this.item.js_horarios.push({
                inicio: "",
                fim: ""
            });
        },

        remover_status(idx) { 
            this.item.js_configs.status.splice(idx, 1);
            this.$forceUpdate();
        },

        acessos(item) { 
          this.$refs.acessos.abrir(
              'App\\azure\\horarioAcesso', 
              item.id_horario_acesso, 
            );
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_horario_acesso: null, 
                st_titulo: "", 
                st_mensagem: "", 
                js_dias: [false, false, false, false, false, false, false],
                js_horarios: [
                    { inicio: "", fim: "" }, 
                ], 
                fl_ativo: true, 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'horario_acessos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'horario_acessos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'horario_acessos',
                dados: item,
            });

        },
    },

    mounted () { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Restrição de Horários de Acesso" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.load();
        },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>